/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useApi } from 'shared_components/context';
import { DiscographyId, useDiscographyIds } from '../useDiscographyIds';
import { LoaderCircle } from 'lucide-react';
import { useCallback, useState } from 'react';
import { useClientId } from 'shared_components/context/client';
import { usePrimaryDiscographyRun } from '../usePrimaryDiscographyRun';

function CachedInfinity() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 16c5 0 7-8 12-8a4 4 0 0 1 0 8c-5 0-7-8-12-8a4 4 0 1 0 0 8" />
    </svg>
  );
}

function PermanentStatusCheck({ artist }: { artist: DiscographyId }) {
  const { getCollectedDiscographyIds } = useDiscographyIds();
  const [updating, setUpdating] = useState(false);
  const { clientId } = useClientId();
  const { adminApi: api } = useApi();
  const { actionsDisabled } = usePrimaryDiscographyRun();

  const handleOnTogglePermanentStatus = useCallback(() => {
    if (!clientId || actionsDisabled || !artist.linked_alias_id) return;

    setUpdating(true);
    api
      .updateBandArtistBand({
        userId: clientId,
        bandId: artist.id,
        artistBandUpdate: {
          linkedAliasId: artist.linked_alias_id,
          isPermanentMember: !Boolean(artist.is_permanent_member),
        },
      })
      .finally(() => {
        getCollectedDiscographyIds(clientId);
        setUpdating(false);
      });
  }, [api, artist, actionsDisabled]);

  return (
    <div
      className={[
        `tw-inline-flex tw-w-6 tw-items-center tw-pl-2 tw-text-lg tw-rounded tw-select-none tw-h-5 tw-justify-center`,
        artist.is_permanent_member
          ? 'tw-text-westburyGreen'
          : 'tw-text-westburyRed',
        !actionsDisabled ? 'tw-cursor-pointer' : '',
      ].join(' ')}
      onClick={handleOnTogglePermanentStatus}
      title={
        artist.is_permanent_member ? 'Permanent member' : 'Non-permanent member'
      }
    >
      {updating ? (
        <LoaderCircle size={12} className="tw-animate-spin tw-text-white" />
      ) : (
        <CachedInfinity />
      )}
    </div>
  );
}

export default PermanentStatusCheck;
